import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, Input, Text, Divider, Box, Textarea, ModalCloseButton } from "@chakra-ui/react";
import { useRef, useState } from "react";

interface UploadMomModal {
    isOpen: boolean;
    onClose: () => void;
}

const UploadMomModal = ({ isOpen, onClose }: UploadMomModal) => {
    const fileRef = useRef<HTMLInputElement | null>(null);
    const [selectedFile, setSelectedFile] = useState<File | null>(null);

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered size="2xl">
            <ModalOverlay />
            <ModalContent borderRadius="10px">
                <ModalHeader className="font-poppins text_semibold text_xl" textAlign="center">Upload MOM</ModalHeader>
                <ModalCloseButton />
                <Divider />

                <ModalBody py={6}>
                    {/* Hidden File Input */}
                    <Input
                        type="file"
                        accept=".xls,.xlsx"
                        ref={fileRef}
                        display="none"
                        onChange={(e) => {
                            if (e.target.files?.[0]) {
                                setSelectedFile(e.target.files[0]);
                            }
                        }}
                    />

                    {/* Upload Box */}
                    <Box
                        border="1px dashed"
                        borderRadius="10px"
                        p={6}
                        textAlign="center"
                        cursor="pointer"
                        bg="gray.50"
                        onClick={() => fileRef.current?.click()}
                    >
                        <Text fontSize="md" fontWeight="600">Upload Excel</Text>
                        <Text fontSize="sm" color="gray.500">
                            Click here to select Excel file
                        </Text>
                        <Button mt={4} size="sm" bg="#F0F5F1" pointerEvents="none">
                            Choose Files
                        </Button>
                    </Box>

                    {selectedFile && (
                        <Text mt={3} textAlign="center" fontSize="sm" color="green.600">
                            Selected file: {selectedFile.name}
                        </Text>
                    )}

                    <Divider my={6} />

                    {/* MOM Fields */}
                    {[
                        "Manager Message",
                        "Host Message",
                        "Key Understanding from the Meeting",
                        "Action Plan Derived from the Meeting"
                    ].map((label) => (
                        <Box key={label} mt={4}>
                            <Text fontWeight="600" mb={2}>{label}</Text>
                            <Textarea placeholder={`Enter ${label.toLowerCase()}...`} />
                        </Box>
                    ))}
                </ModalBody>

                <ModalFooter justifyContent="center" gap={3}>
                    <Button variant="ghost" onClick={onClose}>Cancel</Button>
                    <Button
                        colorScheme="green"
                        isDisabled={!selectedFile}
                        onClick={() => {
                            setSelectedFile(null);
                            onClose();
                        }}
                    >
                        Upload
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default UploadMomModal;
